import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  list (context, opts) {
    const params = opts && Object.keys(opts).length > 0 ? opts : {}
    return new Promise((resolve, reject) => {
      axios
        .get('/api/group', { params })
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  created (context, opts) {
    // TODO check socket after is_admin removed
    axios
      .get(`/api/group/${opts}`)
      .then(({ data }) => {
        if (data.id) {
          context.commit('LIST_ADD', data)
        }
      }).catch(() => {
      })
  },
  updated (context, opts) {
    // if it's in the list, go fetch its new details
    if (context.state.current.id === opts || context.state.list.find((i) => i.id === opts) !== undefined) {
      axios
        .get(`/api/group/${opts}`)
        .then(({ data }) => {
          if (data.id) {
            context.commit('LIST_UPDATE', data)
            if (data.id === context.state.current.id) {
              context.commit('CURRENT', data)
            }
          }
        }).catch(() => {
        })
    }
  },
  destroyed (context, opts) {
    // always try to remove from list
    context.commit('LIST_REMOVE', opts)
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  // ===========================List Edits===============================
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/group', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/group/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  detail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const params = typeof opts === 'object' ? { params: opts } : {}
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/group/${id}`, params)
        .then(({ data }) => {
          // context.commit('LIST_UPDATE', data)
          context.commit('CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  update (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/group/${context.state.current.id}`, context.state.update)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  addUser (context, opts) {
    if (opts.user && opts.group) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/api/user/${opts.user}`, { group: opts.group })
          .then(({ data }) => {
            context.dispatch('detail', context.state.current.id)
            resolve(data)
          }).catch((error) => {
            reject(error)
          })
      })
    }
  }
}
